import { campaignApiGet } from '@/lib/api/campaign-api-client';
import type {
  AuditLogFilters,
  AuditLogPage,
  AuditLogQuery,
  EntityResponse,
} from '../types/audit-log.types';
import { cleanAuditQuery } from '../utils/audit-log-utils';

export const getAuditLog = async (query: AuditLogQuery): Promise<AuditLogPage> => {
  const cleaned = cleanAuditQuery(query);
  const response = await campaignApiGet<EntityResponse<AuditLogPage>>(
    '/v1/audit-log',
    cleaned
  );

  if (response && response.success === false && response.errors?.length) {
    const error = new Error(response.message || 'Validation failed');
    (error as any).errors = response.errors;
    (error as any).status = 400;
    throw error;
  }

  if (!response?.data) {
    return {
      items: [],
      pageInfo: {
        limit: query.limit ?? 50,
        count: 0,
        nextCursor: null,
        hasNext: false,
      },
    };
  }

  return response.data;
};

export const getAuditLogFilters = async (): Promise<AuditLogFilters> => {
  const response = await campaignApiGet<EntityResponse<AuditLogFilters>>(
    '/v1/audit-log/filters'
  );

  if (response && response.success === false && response.errors?.length) {
    const error = new Error(response.message || 'Failed to fetch filters');
    (error as any).errors = response.errors;
    (error as any).status = 400;
    throw error;
  }

  return response?.data ?? {
    actors: [],
    actions: [],
    resourceTypes: [],
  };
};
